import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '@/shared/services';
import { Goal } from '@/core/interfaces';
import { ToolListService } from '@/shared/services/tool-list.service';
import { Router } from '@angular/router';

@Component({
  selector: 'tools-support-content',
  templateUrl: './tools-support-content.component.html',
  styleUrls: ['./tools-support-content.component.css'],
  standalone: false,
})
export class ToolsSupportContentComponent {
  public env = environment;
  public currentPath: string = '';

  constructor(
    public authService: AuthService,
    public toolListService: ToolListService,
    public router: Router,
  ) {}

  ngOnInit(): void {
    // Get the current path directly from the Router
    this.currentPath = this.router.url;

    // Optionally, subscribe to route changes for dynamic updates
    this.router.events.subscribe(() => {
      this.currentPath = this.router.url;
    });
  }

  shouldShowModuleBg(goalList: Goal[]) {
    for (const goal of goalList) {
      if (this.authService.hasPermission(goal.tool_permission)) {
        return true;
      }
    }

    return false;
  }
}
